import { isArray, isEmpty, map } from 'lodash';
import getChangesObject from '../../../../taboola-common-frontend-modules/utils/objectDiff';
import { ENTITY, FORM_MODES } from '../../../config/';
import {
    saveCampaign as campaignsSaveCampaign,
    duplicateCampaign as campaignsDuplicateCampaign,
    duplicateVideoCampaign as campaignsDuplicateVideoCampaign,
    saveBulkCampaigns as campaignSaveBulkCampaigns,
} from '../../../flows';

const getCampaignChanges = ({ editedCampaign, originalCampaign, mode }) => {
    const campaignChanges = getChangesObject(editedCampaign, originalCampaign);

    if (campaignChanges.campaignTargeting && originalCampaign.campaignTargeting) {
        campaignChanges.campaignTargeting = getChangesObject(
            editedCampaign.campaignTargeting,
            originalCampaign.campaignTargeting
        );
        // Need to have diff on third level
        if (
            editedCampaign.campaignTargeting.publisherTargeting &&
            originalCampaign.campaignTargeting.publisherTargeting
        ) {
            campaignChanges.campaignTargeting.publisherTargeting = getChangesObject(
                editedCampaign.campaignTargeting.publisherTargeting,
                originalCampaign.campaignTargeting.publisherTargeting
            );
        }
    }

    // Always include for campaign group gateway budget processing
    if (mode === FORM_MODES.DUPLICATE && !isEmpty(editedCampaign.campaignGroupInfo)) {
        campaignChanges.campaignGroupInfo = editedCampaign.campaignGroupInfo;
    }

    return campaignChanges;
};

const getBulkCampaignChanges = ({ editedCampaigns, originalCampaigns }) =>
    map(editedCampaigns, (editedCampaign, index) => {
        const { id, accountName } = editedCampaign;
        const campaignChanges = getCampaignChanges({ editedCampaign, originalCampaign: originalCampaigns[index] });
        return { ...campaignChanges, id, accountName };
    });

export const saveCampaign =
    ({ accountName, originalCampaign, editedCampaign, entityType, mode }) =>
    dispatch => {
        const campaignChanges = isArray(editedCampaign)
            ? getBulkCampaignChanges({ editedCampaigns: editedCampaign, originalCampaigns: originalCampaign })
            : getCampaignChanges({ editedCampaign, originalCampaign, mode });

        // un-editable campaign fields
        const { accountName: sourceAccountName, id: campaignId } = editedCampaign;
        if (mode === FORM_MODES.DUPLICATE && entityType === ENTITY.CAMPAIGN_VIDEO) {
            return dispatch(
                campaignsDuplicateVideoCampaign({
                    accountId: sourceAccountName,
                    campaignId,
                    changes: campaignChanges,
                    passedDestinationAccountName: accountName,
                    entityType,
                })
            );
        } else if (mode === FORM_MODES.DUPLICATE) {
            return dispatch(
                campaignsDuplicateCampaign({
                    accountId: sourceAccountName,
                    campaignId,
                    changes: campaignChanges,
                    passedDestinationAccountName: accountName,
                    entityType,
                })
            );
        }

        if (mode === FORM_MODES.BULK_EDIT) {
            return dispatch(
                campaignSaveBulkCampaigns({
                    changes: campaignChanges,
                    entityType,
                })
            );
        }

        if (Object.keys(campaignChanges).length) {
            return dispatch(
                campaignsSaveCampaign({
                    accountId: sourceAccountName,
                    campaignId,
                    changes: campaignChanges,
                    entityType,
                })
            );
        }
    };
